<template>
  <section>
    <b-overlay
      :show='loading'
      rounded
      no-center
      opacity='0.6'
      spinner-small
      spinner-variant='primary'
      class='d-inline-block w-100'
      style='min-height: 250px'
    >
      <ModalConfirmAction
        variant='success'
        refModal='approved'
        idModal='approved'
        :loading='loading'
        :description='description'
        :title='title'
        okText="Aprovar"
        canceltext="Cancelar"
        @confirmed='approve'
      ></ModalConfirmAction>

      <ModalConfirmAction
        variant='danger'
        refModal='disapproved'
        idModal='disapproved'
        :loading='loading'
        :description='description'
        :title='title'
        okText="Reprovar"
        canceltext="Cancelar"
        @confirmed='disapproved'
      ></ModalConfirmAction>

      <ModalConfirmAction
        variant='danger'
        refModal='deleteWebAppUserBond'
        idModal='deleteWebAppUserBond'
        :loading='loading'
        :description='description'
        :title='title'
        okText="Sim"
        canceltext="Cancelar"
        @confirmed='deleteWebAppUserBond'
      ></ModalConfirmAction>

      <section class="mb-3">
        <section class="filters">
          <section>
            <label>Data inicial</label>
            <b-form-input
              v-model="webAppUserBondMeta.startDate"
              placeholder="Data inicial"
              type="date"
            >
            </b-form-input>
          </section>

          <section>
            <label>Data final</label>
            <b-form-input
              v-model="webAppUserBondMeta.endDate"
              placeholder="Data final"
              type="date"
            >
            </b-form-input>
          </section>

          <section>
            <label>E-mail Ho Fácil Web</label>
            <b-form-input
              v-model="webAppUserBondMeta.usernameWeb"
              placeholder="Digite o e-mail Ho Fácil Web"
              type="search"
            >
            </b-form-input>
          </section>

          <section>
            <label>E-mail Ho Fácil App</label>
            <b-form-input
              v-model="webAppUserBondMeta.usernameApp"
              placeholder="Digite o e-mail Ho Fácil App"
              type="search"
            >
            </b-form-input>
          </section>
        </section>
        <section class="mt-3 d-flex justify-content-end">
          <section class="">
            <b-button @click="getWebAppUserBonds(1)" variant="success">
              <b-icon
                icon='search'
                font-scale=".9"
                class="mr-1"
              >
              </b-icon>
              <span>Pesquisar</span>
            </b-button>

            <b-button @click="reset()" variant="info" class="ml-2">
              <b-icon
                icon='arrow-repeat'
                class="mr-1"
              >
              </b-icon>
              <span>Limpar filtros</span>
            </b-button>
          </section>
        </section>
      </section>

      <section>
        <base-table
          v-if='webAppUserBonds && webAppUserBonds.length > 0'
          :columns='columns'
          :data='webAppUserBonds'
          :total-items='webAppUserBondMeta.total'
          :start-items='webAppUserBondMeta.skip + 1'
          :max-items='webAppUserBondMeta.limit'
          @set-page='getWebAppUserBonds'
        >
          <template v-slot:body-status='row'>
          <span class="pending" v-if="row.item && row.item.status && row.item.status === 'pending'">
            Pendente
          </span>
            <span class="approved" v-else-if="row.item && row.item.status && row.item.status === 'approved'">
            Aprovado
          </span>
            <span class="disapproved" v-else-if="row.item && row.item.status && row.item.status === 'disapproved'">
            Reprovado
          </span>
            <span v-else>
            -
          </span>
          </template>

          <template v-slot:body-createdAt='row'>
            {{ row.item && row.item.createdAt && row.item.createdAt ? formatDate(row.item.createdAt) : '' }}
          </template>

          <template v-slot:body-actions='row'>
            <section>
              <b-popover
                :target="`${row.item._id}_approved`"
                triggers="hover"
                placement="top"
              >
                <template #title>Aprovar solicitação de vínculo</template>
              </b-popover>

              <b-button
                v-if="row.item && row.item.status && (row.item.status === 'pending' || row.item.status === 'disapproved')"
                :id="`${row.item._id}_approved`"
                variant="outline-success"
                class="mr-2"
                @click="showModalApproved(row.item)"
              >
                <b-icon
                  icon='check'
                >
                </b-icon>
              </b-button>

              <b-popover
                :target="`${row.item._id}_disapproved`"
                triggers="hover"
                placement="top"
              >
                <template #title>Reprovar solicitação de vínculo</template>
              </b-popover>

              <b-button
                v-if="row.item && row.item.status && (row.item.status === 'pending' || row.item.status === 'approved')"
                :id="`${row.item._id}_disapproved`"
                variant="outline-danger"
                @click="showModalDisapproved(row.item)"
              >
                <b-icon
                  icon='x'
                >
                </b-icon>
              </b-button>

              <b-popover
                :target="`${row.item._id}_trash`"
                triggers="hover"
                placement="top"
              >
                <template #title>Excluir solicitação de vínculo</template>
              </b-popover>

              <b-button
                :id="`${row.item._id}_trash`"
                variant="outline-danger"
                class="ml-2"
                @click="showModalDeleteWebAppUserBond(row.item)"
              >
                <b-icon
                  icon='trash'
                >
                </b-icon>
              </b-button>
            </section>
          </template>
        </base-table>
      </section>
    </b-overlay>
  </section>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import format from 'date-fns/esm/format/index'
import ModalConfirmAction from '@/components/ModalConfirmAction.vue'


export default {
  name: 'WebAppUserBond',
  data() {
    return {
      loading: false,
      description: '',
      title: '',
      webAppUserBond: Object,
      columns: [
        { key: 'usernameWeb', value: 'E-mail Ho Fácil Web' },
        { key: 'usernameApp', value: 'E-mail Ho Fácil App' },
        { key: 'status', value: 'Status' },
        { key: 'createdAt', value: 'Data da solicitação' },
        { key: 'actions', value: 'Ações' }
      ]
    }
  },
  components: {
    ModalConfirmAction
  },
  computed: {
    ...mapGetters('webAppUserBond', {
      webAppUserBonds: 'webAppUserBonds',
      webAppUserBondMeta: 'webAppUserBondMeta'
    })
  },
  watch: {},
  methods: {
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb'
    }),
    ...mapActions('webAppUserBond', {
      handleGetAllPaginated: 'handleGetAllPaginated',
      handleApprove: 'handleApprove',
      handleDisapprove: 'handleDisapprove',
      handleDelete: 'handleDelete',
      handleResetMeta: 'handleResetMeta'
    }),
    async reset() {
      this.loading = true
      await this.handleResetMeta()
      await this.handleGetAllPaginated({})
      this.loading = false
    },

    showModalDeleteWebAppUserBond(webAppUserBond) {
      this.webAppUserBond = webAppUserBond
      this.title = 'Excluir solicitação de vínculo'
      this.description = `Deseja realmente excluir essa solicitação de vínculo? <br/> <br/> E-mail Ho Fácil Web: ${webAppUserBond.usernameWeb} <br/>E-mail Ho Fácil App: ${webAppUserBond.usernameApp}`
      this.$bvModal.show('deleteWebAppUserBond')
    },

    hideModalDeleteWebAppUserBond() {
      this.$bvModal.hide('deleteWebAppUserBond')
    },

    async deleteWebAppUserBond() {
      try {
        this.loading = true
        const response = await this.handleDelete(this.webAppUserBond._id)
        let message = response.data.message
        let variant = 'danger'

        if (response.status === 201 || response.status === 200) {
          message = response.data.message
          variant = 'success'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })

        this.hideModalDeleteWebAppUserBond()
        await this.handleGetAllPaginated(this.webAppUserBondMeta)
        this.loading = false
      } catch (e) {

      }
    },

    showModalDisapproved(webAppUserBond) {
      this.webAppUserBond = webAppUserBond
      this.title = 'Reprovar solicitação de vínculo'
      this.description = `Deseja realmente reprovar essa solicitação de vínculo? <br/> <br/> E-mail Ho Fácil Web: ${webAppUserBond.usernameWeb} <br/>E-mail Ho Fácil App: ${webAppUserBond.usernameApp}`
      this.$bvModal.show('disapproved')
    },

    hideModalDisapproved() {
      this.$bvModal.hide('disapproved')
    },

    async disapproved() {
      try {
        this.loading = true
        const response = await this.handleDisapprove(this.webAppUserBond)
        let message = response.data.message
        let variant = 'danger'

        if (response.status === 201 || response.status === 200) {
          message = response.data.message
          variant = 'success'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.hideModalDisapproved()
        await this.handleGetAllPaginated(this.webAppUserBondMeta)
        this.loading = false
      } catch (e) {

      }
    },

    showModalApproved(webAppUserBond) {
      this.webAppUserBond = webAppUserBond
      this.title = 'Aprovar solicitação de vínculo'
      this.description = `Deseja realmente aprovar essa solicitação de vínculo? <br/> <br/> E-mail Ho Fácil Web: ${webAppUserBond.usernameWeb} <br/>E-mail Ho Fácil App: ${webAppUserBond.usernameApp}`
      this.$bvModal.show('approved')
    },

    hideModalApproved() {
      this.$bvModal.hide('approved')
    },

    async approve() {
      try {
        this.loading = true
        const response = await this.handleApprove(this.webAppUserBond)
        let message = response.data.message
        let variant = 'danger'

        if (response.status === 201 || response.status === 200) {
          message = response.data.message
          variant = 'success'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.hideModalApproved()
        await this.handleGetAllPaginated(this.webAppUserBondMeta)
        this.loading = false
      } catch (e) {

      }
    },

    async getWebAppUserBonds(page) {
      try {
        this.loading = true
        const pageCount = page <= 0 ? 1 : page

        const params = {
          ...this.webAppUserBondMeta,
          skip: ((pageCount - 1) * this.webAppUserBondMeta.limit),
        }
        console.log(params)
        await this.handleGetAllPaginated(params)
        this.loading = false
      } catch (e) {

      }
    },
    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy HH:mm:ss')
    }
  },
  async mounted() {
    this.loading = true
    await this.handleGetAllPaginated({})
    this.loading = false
  },
  async created() {
    const breadcrumb = {
      tab: '',
      page: 'Solicitação para vincular conta do HO Fácil Web com HOFácil App',
      subPage: {
        name: 'Solicitação para vincular conta do HO Fácil Web com HOFácil App',
        active: false
      },
      tabs: []
    }
    await this.setBreadcrumb(breadcrumb)
  }
}
</script>

<style lang='scss' scoped>
.pending {
  background: orange;
  padding: 5px 8px;
  border-radius: 6px;
  font-weight: 700;
}

.approved {
  background: #22C55E;
  padding: 5px 8px;
  border-radius: 6px;
  font-weight: 700;
}

.disapproved {
  background: #bc0000;
  padding: 5px 8px;
  border-radius: 6px;
  font-weight: 700;
}

.filters {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  section {
    width: 24.6%;
    min-width: 300px;
  }
}

</style>
